import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Loader } from '../../utils/tools';

function DynamicTitle() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  let evidenceListName = ''

  let title;
  evidenceListName = useSelector(state => state.evidenceList.current.name);
  const loading = useSelector(state => state.evidenceList.currentLoading);

  const operationalLogName = useSelector(state => state.operationalLog.logToEdit?.name);
  const operationalLogLoading = useSelector(state => state.operationalLog.logToEditLoading);

  const titleMap = {
    '/dashboard': 'Prehľady',
    '/evidencelist': 'Evidenčné listy',
    '/evidencelist/:id': evidenceListName,
    '/warehouse': 'Sklady',
    '/container': 'Nádoby',
    '/client': 'Dodávatelia a odberatelia',
    '/branch': 'Prevádzky',
    '/announcement': 'Ohlásenia odpadov',
    '/announcement/detail': 'Detail ohlásenia odpadov',
    '/profile': 'Môj profil',
    '/settings': 'Nastavenia',
    '/billing': 'Predplatné a platby',
    '/consents': 'Súhlasy a povolenia',
    '/operational-log': 'Prevádzkový denník',
    '/operational-log/:id': operationalLogName || 'Prevádzkový denník',
    '/statistics': 'Štatistiky',
    '/ppwr': 'PPWR',
  };

  if (pathnames.length === 0) {
    title = titleMap['/'];
  } else {
    const to = `/${pathnames.slice(0, pathnames.length).join('/')}`;
    const isDynamicId = pathnames.length > 1 && titleMap[`/${pathnames.slice(0, -1).join('/')}/:id`];

    title = isDynamicId
      ? titleMap[`/${pathnames.slice(0, -1).join('/')}/:id`]
      : titleMap[to] || '';
  }

  if (location.pathname === '/dashboard') return null;

  const isLoading = location.pathname.startsWith('/operational-log/') ? operationalLogLoading : loading;

  return (
    <>
      { isLoading ?
          <Loader />
        :
          <h1>{title}</h1>
      }
    </>
  );
}

export default DynamicTitle;
